<div class="chat-container">
  <div class="messages-container" #messagesContainer>
    @for (message of messages; track message; let i = $index) {
      <div
        class="message-container"
        [ngClass]="{
          'assistant-container': message.role === 'assistant',
        }"
      >
        @if (avatarPath !== '' && message.role === 'assistant') {
          <img
            class="avatar"
            [ngClass]="{
              'avatar-first-appearance': message.content === '...',
            }"
            src="{{ avatarPath }}"
          />
        }
        @if (message.role === 'user' || avatarPath === '') {
          <div class="user-avatar"></div>
        }
        @if (message.role === 'user') {
          <div class="user-container">
            <div class="edit-icons-container">
              @if (editingIndex !== i) {
                <div
                  [style.pointer-events]="disableUserInput ? null : 'auto'"
                  [style.cursor]="disableUserInput ? 'default' : 'pointer'"
                  [style.opacity]="disableUserInput ? '0.5' : '1'"
                >
                  <img
                    src="../../../assets/images/tutoria/edit-icon.svg"
                    (click)="startEdit(i)"
                  />
                </div>
              }
              @if (editingIndex === i) {
                @if (isEditMode) {
                  <img
                    src="../../../assets/images/tutoria/send-icon.svg"
                    [style.cursor]="disableUserInput ? 'default' : 'pointer'"
                    (click)="saveEdit(i)"
                  />
                }
                @if (isEditMode) {
                  <img
                    src="../../../assets/images/tutoria/blue-cross.svg"
                    [style.cursor]="disableUserInput ? 'default' : 'pointer'"
                    (click)="cancelEdit()"
                  />
                }
              }
            </div>
            <div class="message" [ngClass]="{ user: message.role === 'user' }">
              @if (editingIndex !== i) {
                <span markdown>{{ message.content }}</span>
              } @else {
                <div class="edit-container">
                  <textarea
                    [(ngModel)]="editMessageContent"
                    (input)="adjustTextareaHeight($event)"
                    class="edit-textarea"
                    autoFocus
                  >
                  </textarea>
                </div>
              }
            </div>
          </div>
        }
        @if (message.role === 'assistant' && message.content !== '...') {
          <div
            class="message"
            [ngClass]="{
              assistant: message.role === 'assistant',
              'assistant-with-content':
                message.role === 'assistant' && message.content !== '',
            }"
          >
            <span>{{ message.content }}</span>
          </div>
        }
        @if (message.role === 'assistant' && message.content === '...') {
          <div class="assistant-typing">
            <span></span><span></span><span></span>
          </div>
        }
      </div>
    }
  </div>
  <div
    class="input-container"
    [ngClass]="{ 'input-disabled': disableUserInput }"
  >
    <textarea
      type="text"
      [disabled]="disableUserInput || isEditMode"
      [placeholder]="
        disableUserInput || isEditMode
          ? isEditMode
            ? 'Considera que editar este mensaje creará una nueva rama de conversación'
            : disabledMessage
          : initialMessage
      "
      [(ngModel)]="userMessage"
      (input)="adjustTextareaHeight($event)"
      rows="1"
    ></textarea>
    <button
      [disabled]="userMessage === '' || disableUserInput || isEditMode"
      (click)="sendMessage()"
    >
      <img src="../../assets/images/icon/arrow-up.svg" />
    </button>
  </div>
</div>
